export default (data, type) => {
  const logsData = []
  data.forEach(log => {
    const [date, time] = log[`${type}At`].split(' ')
    const existed = logsData.some((item, index) => {
      if (item.date === date) {
        logsData[index].content.push({ key: String(Math.random()), time, ...log })
        return true
      }
      return false
    })

    if (!existed) {
      const dateStamp = new Date(date).getTime()
      const nowStamp = new Date().getTime()
      let dateTag = ''
      if (Math.abs(nowStamp - dateStamp) < 86400000) {
        dateTag = 'log.today'
      } else if (Math.abs(nowStamp - dateStamp) < 86400000 * 2) {
        dateTag = 'log.yesterday'
      } else if (Math.abs(nowStamp - dateStamp) < 86400000 * 3) {
        dateTag = 'log.beforeYesterday'
      }

      logsData.push({ date, dateTag, content: [{ key: String(Math.random()), time, ...log }] })
    }
  })
  return logsData
}